import React from 'react';
import { PlatformClosingCta } from '../../shared/components/PlatformClosingCta';
import { PlatformCtaBanner } from '../../shared/components/PlatformCtaBanner';
import { PlatformEduIntro } from '../../shared/components/PlatformEduIntro';
import { PlatformFaqs } from '../../shared/components/PlatformFaqs';
import { PlatformFeatureShowcase } from '../../shared/components/PlatformFeatureShowcase';
import { PlatformPremiumHero } from '../../shared/components/PlatformPremiumHero';
import { PlatformAdvantages } from '../sections/PlatformAdvantages';
import { PlatformSubFeatures } from '../sections/PlatformSubFeatures';
import type { PlatformSubpageConfig } from '../types';

export interface PlatformSubPageLayoutProps {
  config: PlatformSubpageConfig;
  heroVisual?: React.ReactNode;
  children?: React.ReactNode;
}

export const PlatformSubPageLayout: React.FC<PlatformSubPageLayoutProps> = ({
  config,
  heroVisual,
  children,
}) => (
  <div className={`io-site platform-page platform-subpage platform-subpage--premium platform-subpage--${config.slug}`}>
    <PlatformPremiumHero config={config} heroVisual={heroVisual} />
    {config.eduIntro && <PlatformEduIntro eduIntro={config.eduIntro} />}
    <PlatformAdvantages advantages={config.advantages} />
    {config.featureShowcase && <PlatformFeatureShowcase showcase={config.featureShowcase} />}
    {children}
    <PlatformSubFeatures capabilities={config.capabilities} />
    {config.ctaBanner && <PlatformCtaBanner banner={config.ctaBanner} />}
    {config.faqs && <PlatformFaqs faqs={config.faqs} />}
    <div id="get-started" className="platform-sub-get-started">
      <PlatformClosingCta />
    </div>
  </div>
);
